var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"notFoundtext"},[_vm._v("sorry，页面不见了")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('p',{staticClass:"notFoundtext"},[_vm._v("点此返回首页")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e23344d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 3IXR
// module chunks = 0